import {
    AggregationStorageLocation,
    NullableStorageLocationAddress,
    StorageLocationAddress,
} from 'types/documents';

function formatAddress(
    storageInfo: AggregationStorageLocation,
    {toDisplay, storage} = {
        toDisplay: ['country', 'city', 'address'] as (keyof NullableStorageLocationAddress)[],
        storage: true,
    },
) {
    const {storageName, address} = storageInfo;
    const name = storageName ? `${storageName} - ` : '';

    const fullAddress = toDisplay.reduce((t, i) => {
        if (!address || !address[i]) {
            return t;
        }

        const text = (address[i] as StorageLocationAddress[typeof i]).toString();
        const concatinator = t.length ? ', ' : '';

        return t.concat(concatinator, text);
    }, '');

    return `${storage ? name : ''}${fullAddress}`;
}

export {formatAddress};
